import React from 'react';
import { AlertTriangle, CheckCircle, Info, X } from 'lucide-react';

export interface ToastProps {
    message: string;
    type: 'success' | 'error' | 'info';
    onClose: () => void;
}

const getIcon = (type: ToastProps['type']) => {
    switch (type) {
        case 'success':
            return <CheckCircle size={20} />;
        case 'error':
            return <AlertTriangle size={20} />;
        default:
            return <Info size={20} />;
    }
};

export const Toast: React.FC<ToastProps> = ({
    message,
    type,
    onClose,
}) => {
    return (
        <div
            className={`toast-container toast-${type}`}
            role="alert"
            aria-live="polite"
        >
            <div className="toast-content">
                <span className="toast-icon">
                    {getIcon(type)}
                </span>

                <span className="toast-message">
                    {message}
                </span>
            </div>

            <button
                type="button"
                className="toast-close-btn"
                onClick={onClose}
                aria-label="Dismiss notification"
            >
                <X size={16} />
            </button>
        </div>
    );
};